"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTracker = createTracker;

var _beacon = require("./beacon");

var _plugin = require("./plugin");

var _page = require("./page");

function createTracker() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  (0, _beacon.configureBeacon)({
    reporters: options.reporters
  });

  if (options.plugins != null) {
    options.plugins.forEach(function (plugin) {
      (0, _plugin.registerPlugin)(plugin);
    });
  }

  (0, _beacon.addBeaconDelegate)({
    beaconDidSendData: options.beaconDidSendData
  });
  (0, _page.addPageDelegate)({
    pageWillUnload: function pageWillUnload() {
      (0, _beacon.flushBeaconData)();
    }
  });
  (0, _page.startPageLifecycle)();
}